export default __webpack_public_path__ + "static/media/POTENCIA.18f1a287.png";